import React, { useState } from 'react'
import '../Style/Product_Com.css'
import Product_Picture from '../Product_Images/516823.jpg'
import CalenderIcon from '../Logos/calendar.svg'
import PenIcon from '../Logos/pen-tool.svg'
import LinkIcon from '../Logos/external-link.svg'
import EyeIcon from '../Logos/eye.svg'
import RemoveIcon from '../Logos/subtract-circle-minus-remove.svg'
import EditIcon from '../Logos/edit-write.svg'
import PercentIcon from '../Logos/percent.svg'
import MoneyIcon from '../Logos/money-alt-cash-currency.svg'
import ProductIcon from '../Logos/ad-product.svg'
import { Link } from 'react-router-dom'

function Manage_Site_Product_Com(Product_Data) {
    const [ProductData, SetProductData] = useState(Product_Data.Product_Data)
    const [ProductOffer, SetProductOffer] = useState(JSON.parse(ProductData.offer))
    return (
        <>
            <div className='manage-site-products-container'>
                <div className='section_control'>
                    <div className='remove-product'>
                        <img src={RemoveIcon} />
                        <div className='hover'>حذف</div>
                    </div>
                    <div className='see-details'>
                        <img src={EyeIcon} />
                        <div className='hover'>جزئیات</div>
                    </div>
                    <div className='Edit-product'>
                        <img src={EditIcon} />
                        <div className='hover'>تصحیح</div>
                    </div>
                    <Link to={ProductData && ProductData.link ? ProductData.link : null} className='go-to-product'>
                        <img src={LinkIcon} />
                        <div className='hover'>رفتن به محصول</div>
                    </Link>
                </div>
                <div className='section_info'>
                    <div className='important-information-container'>
                        <div className='name-of-product'>{ProductData && ProductData.name ? ProductData.name : null}</div>
                        <div className='added-date'>
                            <div className='text'>تاریخ افزودن: {ProductData && ProductData.added_date ? ProductData.added_date : null}</div>
                            <img src={CalenderIcon} className='calender-icon' />
                        </div>
                        <div className='updated-date'>
                            <div className='text'>تاریخ بروزرسانی: {ProductData && ProductData.updated_date ? ProductData.updated_date : "بروزرسانی وجود ندارد"}</div>
                            <img src={CalenderIcon} className='calender-icon' />
                        </div>
                        <div className='number-of-product'>
                            <img src={ProductIcon} className='product-icon'/>
                            <div className='number-detail-text'>تعداد محصول: {ProductData && ProductData.number > 0 ? ProductData.number : "ناموجود"}</div>
                        </div>
                        <div className='offer-details'>
                            <div className='text'>
                                <img src={PercentIcon} />
                                <div className='offer-detail-text'>جزئیات تخفیف:</div>
                            </div>
                            {!ProductOffer ? <div className='no-offer'>تخفیفی وجود ندارد</div> : null}
                            {ProductOffer ? <div className='offer-percent'>
                                <img src={PercentIcon} />
                                <div className='offer-percent-text'>درصد تخفیف: %{ProductOffer ? ProductOffer.offer_percent : null}</div>
                            </div> : null}
                            {ProductOffer ? <div className='offer-last-price'>
                                <img src={MoneyIcon} />
                                <div className='offer-last-price-text'>قیمت بعد از تخفیف: {ProductOffer ? ProductOffer.offered_price : null} تومان</div>
                            </div> : null}
                        </div>
                        <div className='product-price'>
                            <img src={MoneyIcon} />
                            <div className='product-price-text'>قیمت اصلی محصول: {ProductData ? ProductData.price : null} تومان</div>
                        </div>
                    </div>
                    <div className='product-picture' style={{ backgroundImage: `url(${Product_Picture})` }}></div>
                </div>
            </div>
        </>
    )
}

export default Manage_Site_Product_Com